import { render, staticRenderFns } from "./HomePartnerships.vue?vue&type=template&id=891bb3ba&scoped=true"
import script from "./HomePartnerships.vue?vue&type=script&lang=ts"
export * from "./HomePartnerships.vue?vue&type=script&lang=ts"
import style0 from "./HomePartnerships.vue?vue&type=style&index=0&id=891bb3ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891bb3ba",
  null
  
)

export default component.exports